module.exports = __webpack_public_path__ + "img/logo1.03332449.png";